(function () {
  const body = document.body;
  const toast = document.querySelector('.samaanly-toast');
  const whatsapp = (window.__SAMAANLY_WHATSAPP || '923295811824').replace(/[^\d]/g, '');

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'PKR' }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = count; });
  }

  async function refreshCartDrawer() {
    const itemsNode = document.querySelector('[data-drawer-items]');
    const subtotalNode = document.querySelector('[data-drawer-subtotal]');
    if (!itemsNode) return;
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      setCartCount(cart.item_count);
      if (subtotalNode) subtotalNode.textContent = formatMoney(cart.total_price);
      if (!cart.items.length) {
        itemsNode.innerHTML = '<p class="drawer-empty">Your bag is waiting for something exceptional.</p>';
        return;
      }
      itemsNode.innerHTML = cart.items.map((item) => `
        <article class="cart-item">
          ${item.image ? `<img src="${item.image}&width=160" alt="${item.product_title.replace(/"/g, '&quot;')}">` : ''}
          <div><h3>${item.product_title}</h3><small>${item.quantity} × ${formatMoney(item.final_price)}</small></div>
          <strong>${formatMoney(item.final_line_price)}</strong>
        </article>`).join('');
    } catch (error) { console.warn('Cart refresh failed', error); }
  }

  async function addToCart(form) {
    const button = form.querySelector('[type="submit"]');
    const original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: Number(form.querySelector('[name="quantity"]')?.value || 1) }] }) });
      if (!response.ok) throw new Error('Unable to add item');
      await refreshCartDrawer();
      body.classList.add('drawer-open');
      showToast('Added to your Samaanly bag.');
    } catch (error) { showToast('Could not add this item. Please try again.'); }
    finally { if (button) { button.disabled = false; button.innerHTML = original; } }
  }

  function cartRequiresLogin(event) {
    if (window.__SAMAANLY_CUSTOMER_LOGGED_IN) return;
    event.preventDefault();
    const target = event.currentTarget;
    const loginUrl = `${window.__SAMAANLY_ACCOUNT_URL || '/account/login'}?return_url=${encodeURIComponent(window.location.pathname + window.location.search)}`;
    const message = target.dataset.loginMessage || 'Please log in or create an account before proceeding to payment.';
    showToast(message);
    window.setTimeout(() => { window.location.href = loginUrl; }, 850);
  }

  function openWhatsApp(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const items = Array.from(document.querySelectorAll('[data-whatsapp-item]')).map((node) => node.dataset.whatsappItem).join('\n');
    const fallback = button.dataset.whatsappItem || document.title;
    const text = encodeURIComponent(`Assalam-o-Alaikum Samaanly, I would like to order:\n${items || fallback}\n\nPlease confirm availability and delivery details.`);
    window.open(`https://wa.me/${whatsapp}?text=${text}`, '_blank', 'noopener');
  }

  document.addEventListener('click', async (event) => {
    const quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault();
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(quickAdd.dataset.productId), quantity: 1 }] }) });
        if (!response.ok) throw new Error('Quick add failed');
        await refreshCartDrawer();
        body.classList.add('drawer-open');
        showToast('Added to your Samaanly bag.');
      } catch (error) { showToast('This item could not be added right now.'); }
      return;
    }
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) { document.querySelector('[data-nav]')?.classList.toggle('is-open'); }
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); body.classList.add('drawer-open'); refreshCartDrawer(); }
    if (event.target.closest('[data-cart-close], .drawer-backdrop')) { body.classList.remove('drawer-open'); }
  });

  document.querySelectorAll('[data-add-to-cart]').forEach((form) => form.addEventListener('submit', (event) => { event.preventDefault(); addToCart(form); }));
  document.querySelectorAll('[data-requires-login]').forEach((node) => node.addEventListener('click', cartRequiresLogin));
  document.querySelectorAll('[data-whatsapp-order]').forEach((node) => node.addEventListener('click', openWhatsApp));

  document.querySelectorAll('[data-tilt-card]').forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const rect = card.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - .5;
      const y = (event.clientY - rect.top) / rect.height - .5;
      card.style.transform = `perspective(900px) rotateX(${y * -5}deg) rotateY(${x * 5}deg) translateY(-3px)`;
    });
    card.addEventListener('pointerleave', () => { card.style.transform = ''; });
  });

  refreshCartDrawer();
})();
